import React, { useEffect } from "react";
import {
    PaymentContainer,
    StatusBox,
    CancelIconContainer,
    CancelTitle,
    Message
} from "../../styles/PaymentStatusStyle";
import { isNativeUser } from "../../../utils/common";

const CancelPage = () => {
    let obj = {
        paymentSuccess: false,
        isCancelled: true
    }
    useEffect(() => {
        if (isNativeUser()) {
            setTimeout(() => {
                try {
                    if (window.webkit?.messageHandlers?.ReadRivalsJS) {
                        try {
                            window.webkit?.messageHandlers?.ReadRivalsJS.paymentCancelled?.postMessage(JSON.stringify(obj));
                        } catch (error) {
                            console.log(`Error sending ios javascript callback: ${error}`);
                        }
                    } else if (window.ReadRivalsJS !== undefined) {
                        window.ReadRivalsJS?.paymentCancelled(JSON.stringify(obj));
                    }
                } catch (error) {
                    console.error("Error sending native callback:", error);
                }
            }, 3000);
        }
    }, []);

    return (
        <PaymentContainer>
            <StatusBox>
                <CancelIconContainer>✖</CancelIconContainer>
                <CancelTitle>Payment Cancelled</CancelTitle>
                <Message>You have cancelled the payment request</Message>
            </StatusBox>
        </PaymentContainer>
    );
};

export default CancelPage;